export default __webpack_public_path__ + "static/media/top.efd53d96.png";